import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PublicLayoutComponent } from './layout/publicLayout.component';
import { LoginComponent } from './login/login.component';
import { VerifyComponent } from './login/verify/verify.component';
import { MaintenanceComponent }
    from './maintenance/maintenance.component';
import { ShareAccessComponent }
    from './shareAccess/shareAccess.component';

const publicRoutes: Routes = [
{
        path: '',
//        redirectTo: '/login',
        pathMatch: 'full',
        component: PublicLayoutComponent,
        children: [
            {path: '', component: LoginComponent}]        
},
{
    path: 'login',
    component: PublicLayoutComponent,
    children: [
        {path: '', component: LoginComponent}]
},
{
    path: 'login/verify',
    component: PublicLayoutComponent,
    children: [
        {path: '', component: VerifyComponent}]
},
{
    path: 'maintenance',
    component: PublicLayoutComponent,
    children: [
        {path: '', component: MaintenanceComponent}]
},
{
    path: 'share/:token',
    component: PublicLayoutComponent,
    children: [
        {path: '', component: ShareAccessComponent}]
}];

@NgModule({
    imports: [
        RouterModule.forChild(publicRoutes),
        VerifyComponent,
        MaintenanceComponent,
        ShareAccessComponent
    ],
    exports: [RouterModule]
})
export class PublicRoutingModule { }
